import Tooltip from "./components/Tooltip.vue";
import Collapse from "./components/Collapse.vue";
import collapseDirective from "./directives/collapse";

export {
  Tooltip,
  Collapse,
  collapseDirective,
}

export default {
  install(Vue) {
    Vue.component('tooltip', Tooltip);
    Vue.component('collapse', Collapse);
    Vue.directive('collapse', collapseDirective);
  },
};
